import { render, staticRenderFns } from "./gasCb.vue?vue&type=template&id=f68995c2&scoped=true"
import script from "./gasCb.vue?vue&type=script&lang=js"
export * from "./gasCb.vue?vue&type=script&lang=js"
import style0 from "./gasCb.vue?vue&type=style&index=0&id=f68995c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68995c2",
  null
  
)

export default component.exports